// src/components/ui/ArticleCard.js
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';
import styles from './ArticleCard.module.css';

function formatDate(dateStr, lang) {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString(lang === 'fa' ? 'fa-IR' : 'en-US', {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  } catch { return dateStr; }
}

export default function ArticleCard({ article }) {
  const { t, ui, lang } = useLang();

  return (
    <Link to={`/blog/${article.slug}`} className={styles.card}>
      <div className={styles.cover}>
        {article.image
          ? <img src={article.image} alt={t(article, 'title')} className={styles.img} />
          : <span className={styles.emoji}>{article.cover_emoji || '🕯️'}</span>
        }
        {article.category && (
          <span className={styles.catTag} style={{ background: article.category.color }}>
            {t(article.category, 'name')}
          </span>
        )}
      </div>
      <div className={styles.body}>
        <div className={styles.meta}>
          <span>{formatDate(article.published_at, lang)}</span>
          <span>{article.read_time_minutes} {ui('دقیقه مطالعه', 'min read')}</span>
        </div>
        <h3 className={styles.title}>{t(article, 'title')}</h3>
        <p className={styles.excerpt}>{t(article, 'excerpt')}</p>
        {article.tags?.length > 0 && (
          <div className={styles.tags}>
            {article.tags.slice(0, 3).map((tag) => (
              <span key={tag.id} className={styles.tag}>{t(tag, 'name')}</span>
            ))}
          </div>
        )}
        <span className={styles.more}>{ui('ادامه مطلب ←', 'Read More →')}</span>
      </div>
    </Link>
  );
}
